import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';

import { isWeb, Popup, getLinkingModalConfig, navigationRef, getNCFileFromVersions } from '@helpers';
import { fullWidth, scale } from '@components/frame';
import ActionMenu from '@components/common/actionMenu';
import NCFileType from '@components/common/NCFileType';
import { shareNCFile } from '@components/common/NCFile/helpers';
import { connect } from 'react-redux';
import { useNavigationCheck } from '@v2/pages/machines/hooks/useNavigationCheck';
import { sendNcFileToMachine } from '@reducers/machines';
import { setNCFileContentSize } from '@reducers/details';
import SendNCFileModal from '@components/ncFileVersionDetails/components/sendNCFile/sendNCFileModal';

const ActionsModal = (props) => {
  const {
    panelViewMode,
    setActionsModalOpen,
    C,
    selectedItem,
    ncFileId,
    featureFlags,
    generateNCFileURL,
    ncFileData: { data: ncFileData },
    machines,
    top,
    right,
    sendNcFileToMachine,
    ncFileContentSize,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const { safeIsMachinesScreenCheck: isMachinesScreen } = useNavigationCheck();

  const downloadNCFile = async () => {
    setIsLoading(true);
    try {
      await shareNCFile({ generateNCFileURL, selectedItem, isDetailsScreen: !isMachinesScreen, ncFileData });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      setActionsModalOpen(false);
    }
  };

  const selected = getNCFileFromVersions(ncFileData?.versions);
  const favorite = ncFileData?.versions?.find((i) => i.isFavorite);

  const items = [
    {
      lable: {
        color: 'Label/Light/Primary',
        name: 'Edit',
      },
      hide: !ncFileId,
      icon: {
        name: 'edit',
        width: isWeb ? 15 : 12,
        height: isWeb ? 15 : 12,
        color: 'Label/Light/Primary',
      },
      onPress: () => {
        setActionsModalOpen(false);
        Popup({
          Component: (p) => <NCFileType {...{ ...p, selectedItem, context: 'ncFile', isMachinesScreen }} />,
          ...getLinkingModalConfig(scale, fullWidth),
        });
      },
    },
    {
      lable: {
        color: 'Label/Light/Primary',
        name: 'Send To Machine',
      },
      iconsGap: 4,
      icons: [
        {
          name: 'arrow',
          width: 8,
          height: 7,
          color: 'Label/Light/Primary',
          transform: 'rotate(180)',
        },
        {
          name: 'sendToMachine',
          width: 19,
          height: 15,
          color: 'Label/Light/Primary',
        },
      ],
      onPress: () => {
        Popup({
          Component: (p) => (
            <SendNCFileModal
              {...{
                ...p,
                C,
                close: p.hide,
                machines,
                NCFile: ncFileData,
                favorite,
                selected,
                sequenceNumber: selected?.sequenceNumber,
                firstRunOn: selected?.firstRanOn,
                firstRunOnMachineName: selected?.firstRanByMachineName,
                sendNcFileToMachine,
                contentSize: ncFileContentSize,
              }}
            />
          ),
        });
      },
    },
    {
      lable: {
        color: 'Label/Light/Warning',
        name: 'Delete',
      },
      icon: {
        name: 'remove',
        width: isWeb ? 17 : 15,
        height: isWeb ? 18 : 17,
        color: 'Label/Light/Warning',
      },
      // isLoading: isRemovingPI,
      onPress: () => {},
    },
  ];

  return (
    <View
      style={{
        width: fullWidth,
        height: '100%',
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: C('Overlay/Light/Dim light'),
      }}
    >
      <TouchableOpacity style={{ width: '100%', height: '100%', alignItems: 'center' }} onPress={() => setActionsModalOpen(false)} activeOpacity={1}>
        <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
          <View
            style={{
              position: 'absolute',
              top: top ? scale(top) : scale(panelViewMode ? 40 : 65) + (!isWeb ? scale(20) : scale(40)),
              right: scale(right ?? 5),
              backgroundColor: C('Background/Light/Field'),
              borderRadius: scale(12),
            }}
          >
            <ActionMenu {...{ C, items }} />
          </View>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default connect(
  ({ details: { ncFileData, ncFileContentSize }, machines: { machines }, user: { featureFlags } }) => ({
    ncFileData,
    machines,
    featureFlags,
    ncFileContentSize,
  }),
  { sendNcFileToMachine, setNCFileContentSize }
)(ActionsModal);
